var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.91406 2.375C6.79688 2.375 6.71875 2.45312 6.64062 2.53125L5.89844 3.625H11.5625L10.8203 2.53125C10.7812 2.45312 10.6641 2.375 10.5469 2.375H6.91406ZM13.8281 3.625H14.3359H16.25H16.5625C17.0703 3.625 17.5 4.05469 17.5 4.5625C17.5 5.10938 17.0703 5.5 16.5625 5.5H16.0938L15.1562 18.1953C15.0391 19.5234 13.9844 20.5 12.6562 20.5H4.80469C3.47656 20.5 2.42188 19.5234 2.30469 18.1953L1.36719 5.5H0.9375C0.390625 5.5 0 5.10938 0 4.5625C0 4.05469 0.390625 3.625 0.9375 3.625H1.25H3.125H3.63281L5.07812 1.47656C5.46875 0.890625 6.17188 0.5 6.91406 0.5H10.5469C11.2891 0.5 11.9922 0.890625 12.3828 1.47656L13.8281 3.625ZM14.2188 5.5H3.24219L4.17969 18.0781C4.21875 18.3906 4.49219 18.625 4.80469 18.625H12.6562C12.9688 18.625 13.2422 18.3906 13.2812 18.0781L14.2188 5.5Z",
    fill: "#031621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1d0ffe564eacb41d108bb8ba5742d0ca.svg";
export { ForwardRef as ReactComponent };